import type { RouteObject } from 'react-router';
import { Navigate, useParams } from 'react-router';

import { PATHNAMES } from 'constants/constants';
import { lazyRoute } from 'utils/lazyRoute';

const AnticipationApp = lazyRoute(
  () => import('features/Anticipation/components/AnticipationApp'),
  m => m.AnticipationApp,
);

const RedirectEditToSearch = () => {
  'use memo';

  const { id = '', resultId } = useParams();
  const target = resultId
    ? `${PATHNAMES.anticipation}/${id}/search/${resultId}`
    : `${PATHNAMES.anticipation}/${id}/search`;
  return <Navigate to={target} replace />;
};

export const anticipationRoutes: RouteObject[] = [
  { path: `${PATHNAMES.anticipation}/new`, lazy: AnticipationApp },
  { path: `${PATHNAMES.anticipation}/:id`, lazy: AnticipationApp },
  { path: `${PATHNAMES.anticipation}/:id/search/:resultId?`, lazy: AnticipationApp },
  { path: `${PATHNAMES.anticipation}/:id/results/:resultId?`, lazy: AnticipationApp },
  { path: `${PATHNAMES.anticipation}/:id/data-table/:dataTableId?/:resultId?`, lazy: AnticipationApp },
  { path: `${PATHNAMES.anticipation}/:id/report/:execReportId?/:resultId?`, lazy: AnticipationApp },
  { path: `${PATHNAMES.anticipation}/:id/edit/:resultId?`, Component: RedirectEditToSearch },
];
